<div class="d-flex justify-content-between align-items-center bg-secondary mt-3 w-100 text-white px-4 py-2"
    *ngIf="students.length > 0">
    <label class="fs-5 m-0"><span class="vag-bold-font">ALUMNO</span> {{students[studentCurrent].fullname}}</label>
    <div class="d-flex">
        <button [disabled]="!students[studentCurrent - 1]" class="btn mx-1" (click)="decreaseIndex()">
            <fa-icon [icon]="chevronLeft" class="text-white"></fa-icon>
        </button>
        <button [disabled]="!students[studentCurrent + 1]" class="btn mx-1" (click)="increaseIndex()">
            <fa-icon [icon]="chevronRight" class="text-white"></fa-icon>
        </button>
    </div>

</div>
<div class="pt-3" *ngIf="students.length > 0">
    <div class="d-flex border-bottom pb-2 border-black">
        <div class="col vag-bold-font">
            Fecha de nacimiento
        </div>
        <div class="col vag-bold-font">
            Edad
        </div>
        <div class="col vag-bold-font">
            Centro
        </div>
    </div>
    <div class="d-flex border-bottom pb-2 border-black mt-2">
        <div class="col">
            {{getDate(students[studentCurrent].dob)}} <img class="lapiz" src="../../../assets/img/lapiz.PNG" width="24"
                (click)="modificar('EDITAR Fecha de nacimiento', null, student, students[studentCurrent].id)">
        </div>
        <div class="col">
            {{students[studentCurrent].age}}
        </div>
        <div class="col">
            <div *ngIf="students[studentCurrent].centroDescr">
                {{students[studentCurrent].centroDescr}}
            </div>
        </div>
    </div>
    <div class="d-flex border-bottom pb-2 border-black mt-2">
        <div class="col vag-bold-font">
            Curso
        </div>
        <div class="col vag-bold-font">
            Año académico
        </div>
        <div class="col vag-bold-font">
            Horario clases
        </div>
    </div>
    <div class="d-flex border-bottom pb-2 border-black mt-2"
        *ngFor="let course of students[studentCurrent]?.courseInfoArr">
        <div class="col">
            {{course.description}}
        </div>
        <div class="col">
            <div *ngIf="course.serieName">
                {{showSerie(course.serieName)}}
            </div>
        </div>
        <div class="col">
            {{getSchedules(course)}}
        </div>
    </div>
    <div class="d-flex border-bottom pb-2 border-black mt-2">
        <div class="col vag-bold-font">
            Inscripción
        </div>
        <div class="col vag-bold-font">
            Fin de curso
        </div>
        <div class="col vag-bold-font">
            Estado
        </div>
    </div>
    <div class="d-flex border-bottom pb-2 border-black mt-2"
        *ngFor="let course of students[studentCurrent]?.courseInfoArr">
        <div class="col">
            {{getDate(user.registrationDate)}}
            <!--{{getDate(getDataFromStatusCourses(course.id, 'registrationDate'))}}-->
        </div>
        <div class="col">
            {{getDate(course.endDate)}}
        </div>
        <div class="col" style="text-transform: capitalize;">
            {{getCourse(course.id)}}
            <!--{{getDataFromStatusCourses(course.id, 'courseStatus')}}-->
        </div>
    </div>
    <!-- <div class="d-flex justify-content-end pb-2 border-black mt-4">
        <button type="button" class="close" class="btn btn-primary" (click)="newInscription();">
            Nueva inscripción
        </button>
    </div> -->
</div>
<div *ngIf="cargando" class="cargando">
    <mat-spinner></mat-spinner>
</div>